<div class="registration-layout">
  <img alt="" [src]="'logos/login-logo.svg' | contentAssetImage" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
